export default {
  'pages.adminFriendTpl.title': '好友预设模板',
  'pages.adminFriendTpl.desc': '管理轻消息预设：常用语 / 表情 / 预置图片',
  'pages.adminFriendTpl.add': '新增模板',
  'pages.adminFriendTpl.edit': '编辑模板',
  'pages.adminFriendTpl.delete': '删除',
  'pages.adminFriendTpl.created': '已新增模板',
  'pages.adminFriendTpl.updated': '已更新模板',
  'pages.adminFriendTpl.deleted': '已删除模板',
  'pages.adminFriendTpl.enabled': '已启用',
  'pages.adminFriendTpl.disabled': '已停用',
  'pages.adminFriendTpl.opFail': '操作失败',
  'pages.adminFriendTpl.uploaded': '上传成功',
  'pages.adminFriendTpl.uploadFail': '上传失败',
  'pages.adminFriendTpl.upload': '上传',
  'pages.adminFriendTpl.colId': 'ID',
  'pages.adminFriendTpl.colCode': '模板 code',
  'pages.adminFriendTpl.colTenant': '归属',
  'pages.adminFriendTpl.tenantPublic': '平台公共',
  'pages.adminFriendTpl.colType': '类型',
  'pages.adminFriendTpl.colContent': '内容',
  'pages.adminFriendTpl.colSort': '排序',
  'pages.adminFriendTpl.colEnabled': '启用',
  'pages.adminFriendTpl.colActions': '操作',
  'pages.adminFriendTpl.typeText': '文字',
  'pages.adminFriendTpl.typeEmoji': '表情',
  'pages.adminFriendTpl.typeImage': '图片',
  'pages.adminFriendTpl.code': '模板 code',
  'pages.adminFriendTpl.codeRequired': '请输入唯一 code（如 img_bless / emoji_happy）',
  'pages.adminFriendTpl.codeMax': '最多 64 个字符',
  'pages.adminFriendTpl.codeImmutable': 'code 创建后不可修改',
  'pages.adminFriendTpl.codeTip': '唯一标识，发送消息时按 code 引用',
  'pages.adminFriendTpl.tplType': '模板类型',
  'pages.adminFriendTpl.imageUrl': '图片/表情包 URL',
  'pages.adminFriendTpl.imageUrlRequired': '图片模板必须提供 URL',
  'pages.adminFriendTpl.emojiUrlTip': '表情包图片可选；不填则用下方表情字符',
  'pages.adminFriendTpl.imageUploadTip': '大图走 OSS；小图（≤150KB）建议用下方 base64 直存',
  'pages.adminFriendTpl.imageData': '小图 base64（直存数据库）',
  'pages.adminFriendTpl.imageDataTip':
    '选择本地小图（≤150KB）自动转 base64 入库，无需 OSS；与上方 URL 二选一，base64 优先',
  'pages.adminFriendTpl.imageDataPick': '选择小图',
  'pages.adminFriendTpl.imageDataClear': '清除',
  'pages.adminFriendTpl.imageDataLoaded': '小图已载入（base64）',
  'pages.adminFriendTpl.imageDataTooLarge': '小图超过 150KB，请改用上方 OSS 上传',
  'pages.adminFriendTpl.emojiChar': '表情字符',
  'pages.adminFriendTpl.imageCaption': '图片附言（可选）',
  'pages.adminFriendTpl.textContent': '文字内容',
  'pages.adminFriendTpl.textRequired': '请输入文字内容',
  'pages.adminFriendTpl.emojiCharRequired': '表情字符与图片至少填一项',
  'pages.adminFriendTpl.emojiCharTip': '如 😊；填了字符后图片可留空',
  'pages.adminFriendTpl.sort': '排序值',
  'pages.adminFriendTpl.on': '启用',
  'pages.adminFriendTpl.off': '停用',
  'pages.adminFriendTpl.confirmDelete': '删除模板不影响已发送的历史消息，确定删除？',
};
